import { render, staticRenderFns } from "./QRPh.vue?vue&type=template&id=1da65215"
import script from "./QRPh.vue?vue&type=script&lang=js"
export * from "./QRPh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports